import CorrelatedServicesListComponent from "./correlated-services-list";

function CorrelatedServicesList({
  services,
  fromAdmin,
  offer,
  className,
  allAnnouncements,
  announcement,
}) {
  return (
    <CorrelatedServicesListComponent
      services={chekOffer(services, offer.correlatedServices)}
      allAnnouncements={allAnnouncements}
      announcement={announcement}
      offer={offer}
      fromAdmin={fromAdmin}
      className={className}
    />
  );
}

function chekOffer(services, selectedServices) {
  return services.map((announcement) => {
    return {
      ...announcement,
      isInOffer: contains(selectedServices, announcement.id),
    };
  });
}

function contains(list, element) {
  return list?.indexOf(element) > -1;
}

export default CorrelatedServicesList;
